import { Injectable } from '@angular/core';
import { AppConfig } from '../models/config/appConfig';
import { Tenant } from '../models/tenant';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AppConfigService {
  public config: AppConfig;

  public initialized: boolean = false;
  public loadError: boolean = false;
  public redirectUri: string;
  public logoutRedirectUri: string;
  public tenant$: BehaviorSubject<Tenant> = new BehaviorSubject<Tenant>(null);
  private _tenant: Tenant;

  constructor(private http: HttpClient) {}

  get baseApiUrl(): string {
    return this.config.baseApiUrl;
  }

  public get tenant() {
    return this._tenant;
  }
  public set tenant(value: Tenant) {
    this._tenant = value;
    this.tenant$.next(value);
  }

  refreshTenant() {
    this.http.get(this.baseApiUrl.concat('tenants/current')).subscribe((res) => {
      this.tenant = Tenant.parse(res);
    });
  }
}
